<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="''"></navBox>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="search_box">
						<div class="search_main">
							<div
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								class="search_el"
							>
								<van-icon name="search" size="20px" color="#999999" class="icon_left" />
								<input v-model="searchVal" ref="searchDom" placeholder="Please enter keyword" @keyup.enter="searchClick" />
								<van-icon name="down" size="22px" color="#C8000A" class="icon_right" @click="searchClick" />
							</div>
						</div>
					</div>
					<div>
						<div
							data-aos="fade-left"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
							class="tips_box"
						>
							<div class="tit">Results</div>
							<div class="txt">Total: {{ total }}</div>
						</div>
						<div v-if="searchList.length > 0">
							<div class="list_box">
								<div
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									v-for="(value, index) in searchList"
									:key="index"
									class="list_el"
									@click="goInfo(value)"
								>
									<div class="left">
										<img :src="webUrl + value.thumb" />
									</div>
									<div class="right">
										<div class="tit">{{ value.leixing == 'News' ? value.title : value.name }}</div>
										<div class="txt">{{ value.content }}</div>
										<div class="tips">{{ value.leixing == 'News' ? 'Article' : 'Product' }}</div>
									</div>
								</div>
							</div>
							<div class="page_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<el-pagination
									:small="false"
									background
									layout="prev, pager, next"
									:total="total"
									:page-size="12"
									@current-change="pageChange"
								>
								</el-pagination>
							</div>
						</div>
						<div
							v-else
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<van-empty image="search" description="No Data" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { UPURL } from '@/util/util'
import { searchList } from '@/api/public'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			searchVal: '',
			page: 1,
			total: 0,
			searchList: [],
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
		if(that.$route.query.search) {
			that.searchVal = that.$route.query.search;
			that.getList();
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击查看详情
		goInfo(value) {
			let that = this;
			if(value.leixing == 'Products') {
				let routeData = that.$router.resolve({name: "ProductInfo", params: { productInfoId: value.id + '.html' } });
				// window.open(routeData.href, '_blank');
				window.location.href = routeData.href;
			}else {
				let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
				// window.open(routeData.href, '_blank');
				window.location.href = routeData.href;
			}
		},
		//点击搜索
		searchClick() {
			let that = this;
			if(that.searchVal) {
				that.getList();
			}else {
				that.$toast('Please enter keyword');
			}
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList();
		},
		//搜索
		getList() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			searchList({
				page: that.page,
				page_size: 12,
				keyword: that.searchVal,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.searchList = res.data.data;
				that.total = res.data.total;
				that.$toast.clear();
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		.block_1_main{
			width: 1200px;
			margin: 0 auto;
			.page_box{
				padding-bottom: 50px;
				text-align: center;
			}
			.list_box{
				padding: 50px 0 80px 0;
				.list_el{
					display: flex;
					align-items: center;
					padding: 20px 0;
					border-bottom: 1px solid #EEEEEE;
					cursor: pointer;
					.right{
						flex: 1;
						padding-left: 70px;
						.tips{
							display: inline-block;
							margin-top: 30px;
							padding: 4px 14px;
							background: #F9F8F6;
							border-radius: 6px 6px 6px 6px;
							border: 1px solid #EEEEEE;
							color: #666666;
						}
						.txt{
							padding-top: 20px;
							font-size: 16px;
							line-height: 1.8;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 3;
							-webkit-box-orient: vertical;
						}
						.tit{
							font-size: 30px;
							font-weight: bold;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							-webkit-box-orient: vertical;
						}
					}
					.left{
						img{
							width: 430px;
						}
					}
				}
			}
			.tips_box{
				.tit{
					font-size: 24px;
					font-weight: bold;
				}
			}
			.search_box{
				width: 100%;
				.search_main{
					padding: 40px 0 40px 0;
					.search_el{
						width: 100%;
						margin: 0 auto;
						position: relative;
						.icon_close{
							position: absolute;
							right: -100px;
							top: -35px;
							cursor: pointer;
						}
						.icon_left{
							position: absolute;
							top: 16px;
						}
						.icon_right{
							position: absolute;
							top: 16px;
							right: 0;
							transform: rotate(-90deg);
							cursor: pointer;
						}
						input{
							width: 100%;
							height: 60px;
							line-height: 60px;
							font-size: 20px;
							border: none;
							border-bottom: 1px solid #C8000A;
							color: #C8000A;
							padding: 0 38px;
							background-color: transparent;
						}
					}
				}
			}
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>